import ActionsForm from '@/shared/mixins/actionsForm'
import Draggable from 'vuedraggable'
import { loading, toast } from '@/shared/utils/UIHelper'
import ModalMovimentacaoColuna from '@/views/private/crm/board/modal/collumns/movimentacao-coluna/ModalMovimentacaoColuna.vue'
import TableMovimentacaoQuadro from '@/views/private/crm/board/modal/collumns/movimentacao-quadro/TableMovimentacaoQuadro.vue'
import TableTransferenciaQuadro from '@/views/private/crm/board/modal/collumns/movimentacao-quadro/TableTransferenciaQuadro.vue'
import ModalNotificacao from '../notificacao-usuario/ModalNotificacao.vue'

import BoardRepository from '@/shared/http/repositories/crm/board.js'
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
import ColumnEvents from './columnEvents'
import SerasaModal from '../serasa/serasaFollowUp.vue'
import HsmModal from '../hsmModal/HsmModal.vue'
import ModalBlockAjuizamento from '../block-ajuizamento/ModalBlockAjuizamento.vue'

export default {
  name: 'BoardCollumns',
  mixins: [ActionsForm],
  props: {
    board: {
      type: Object,
      default: null
    },
    boardColumns: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      columnEvents: ColumnEvents,
      boardName: null,
      localColumns: [],
      localBoard: [],
      localRemove: [],
      editing: {
        columnID: null,
        oldTitle: null,
        oldValue: null,
        oldColor: null,
        oldHoursUntilAlert: null,
        oldHoursUntilAlertContact: null,
        oldObservacao: null,
        oldObrigatorio: false
      },
      eventoId: null,
      usuarioList: null,
      diasAtrasoProdutoCard: null,
      movimentacaoModalOpen: false,
      movimentacaoModalItems: [],
      notificacaoModalOpen: false,
      notificacaoModalItems: [],
      blockAjuizamentoModalOpen: false,
      blockAjuizamentoModalItems: [],
      hsmModalAttributes: [],
      serasaModalAttributes: []
    }
  },
  components: {
    ModalBlockAjuizamento,
    SerasaModal,
    ModalMovimentacaoColuna,
    TableMovimentacaoQuadro,
    TableTransferenciaQuadro,
    ModalNotificacao,
    HsmModal,
    Draggable
  },
  computed: {
    newIndexName () {
      let result = 1
      if (this.localColumns && this.localColumns.length > 0) {
        this.localColumns.forEach((el) => {
          result++
        })
      }
      return result
    }
  },
  beforeMount () {
    // this.localColumns = JSON.parse(JSON.stringify(this.columns))
    // this.localBoard = JSON.parse(JSON.stringify(this.board))
    this.editing.columnID = null
  },
  methods: {
    showModal () {
      this.onClear()
      this.boardName = this.board ? this.board.nome : null
      this.onSetLocalColumns()
      this.$refs['modal-column'].show()
    },
    hideModal () {
      this.$refs['modal-column'].hide()
    },
    onLoad () {
      this.onClear()
    },
    onMoveColumns () {
      let localColumns = []

      this.localColumns.map((column, index) => {
        column.position = index
        localColumns.push(column)
      })

      this.localColumns = localColumns
    },
    onAdd () {
      // this.localColumns.unshift({
      this.localColumns.push({
        id: parseInt('-' + this.newIndexName),
        boardId: this.board.id,
        name: 'Nova Coluna ' + this.newIndexName,
        color: 'blue',
        value: null,
        hoursUntilAlertContact: null,
        hoursUntilAlert: null,
        observacao: null,
        obrigatorio: false,
        eventoColuna: [ColumnEvents.SEM_ACAO],
        inative: false
      })
    },
    onSave () {
      this.editing.columnID = null
    },
    onEdit (column) {
      this.editing.columnID = column.id
      this.editing.oldTitle = column.title
      this.editing.oldValue = column.value
      this.editing.oldColor = column.color
      this.editing.oldHoursUntilAlertContact = column.hoursUntilAlertContact
      this.editing.oldHoursUntilAlert = column.hoursUntilAlert
      this.editing.oldObservacao = column.oldObservacao
      this.editing.oldObrigatorio = column.oldObrigatorio
    },
    onCancel (column) {
      column.title = this.editing.oldTitle
      column.value = this.editing.oldValue
      column.color = this.editing.oldColor
      column.hoursUntilAlertContact = this.editing.oldHoursUntilAlertContact
      column.hoursUntilAlert = this.editing.oldHoursUntilAlert
      column.oldObservacao = this.editing.oldObservacao
      column.oldObrigatorio = this.editing.oldObrigatorio

      this.$nextTick(() => {
        this.editing.columnID = null
        this.editing.oldHoursUntilAlertContact = null
        this.editing.oldHoursUntilAlert = null
        this.editing.oldObservacao = null
        this.editing.oldTitle = null
        this.editing.oldValue = null
        this.editing.oldColor = null
      })
    },
    onRemove (column) {
      if (column.id && column.id > 0) {
        BoardRepositoryV2.Column_Delete(column.board.id, column.id)
          .then((response) => {
            if (response.status === 200) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.$emit('Back')
            }
          })
          .catch(this.onException)
      }
      let index = this.localColumns.findIndex(c => c.id === column.id)
      this.localColumns.splice(index, 1)
    },
    onSetLocalColumns () {
      this.localColumns = []
      this.boardColumns.forEach(element => {
        this.localColumns.push({
          id: element.id,
          boardId: element.board.id,
          name: element.nome,
          color: element.cor,
          value: element.percentual,
          hoursUntilAlertContact: element.hoursUntilAlertContact,
          hoursUntilAlert: element.hoursUntilAlert,
          observacao: element.observacao,
          obrigatorio: element.obrigatorio,
          eventoColuna: element.eventoColuna,
          inative: element.inative,
          eventoId: element.eventoDTO ? element.eventoDTO.id : null,
          usuarioList: element.usuarioList ? element.usuarioList : null,
          diasAtrasoProdutoCard: element.diasAtrasoProdutoCard ? element.diasAtrasoProdutoCard : null,
          movimentacaoAutoAtrasoProduto: element.movimentacaoAutoAtrasoProduto ? element.movimentacaoAutoAtrasoProduto : null,
          movimentacaoAutoTempoBoardColumn: element.movimentacaoAutoTempoBoardColumn ? element.movimentacaoAutoTempoBoardColumn : null,
          hsmVinculadoId: element.hsmVinculado ? element.hsmVinculado.id : null,
          modeloVinculadoId: element.modeloVinculado ? element.modeloVinculado.id : null,
          provedorVinculadoId: element.provedorVinculado ? element.provedorVinculado.id : null
        })
      })
    },
    async onSaveBoardColumn () {
      if (this.editing.columnID === null) {
        loading.push()
        let columnsCreate = []
        let columnsUpdate = []
        let i = 0
        this.localColumns.forEach(element => {
          if (element.id && element.id > 0) {
            columnsUpdate.push({
              'id': element.id,
              'boardId': element.boardId,
              'nome': element.name,
              'posicao': i,
              'cor': element.color,
              'hoursUntilAlertContact': element.hoursUntilAlertContact ? parseInt(element.hoursUntilAlertContact) : null,
              'hoursUntilAlert': element.hoursUntilAlert ? parseInt(element.hoursUntilAlert) : null,
              'percentual': element.value ? parseInt(element.value) : null,
              'observacao': element.observacao,
              'obrigatorio': element.obrigatorio,
              'eventoColuna': element.eventoColuna,
              'inative': element.inative,
              'eventoId': element.eventoId,
              'usuarioList': element.usuarioList,
              'diasAtrasoProdutoCard': element.diasAtrasoProdutoCard,
              'hsmVinculadoId': element.hsmVinculadoId,
              'modeloVinculadoId': element.modeloVinculadoId,
              'provedorVinculadoId': element.provedorVinculadoId
            })
          } else {
            columnsCreate.push({
              'id': null,
              'boardId': element.boardId,
              'nome': element.name,
              'posicao': i,
              'cor': element.color,
              'hoursUntilAlertContact': element.hoursUntilAlertContact ? parseInt(element.hoursUntilAlertContact) : null,
              'hoursUntilAlert': element.hoursUntilAlert ? parseInt(element.hoursUntilAlert) : null,
              'percentual': element.value ? parseInt(element.value) : null,
              'observacao': element.observacao,
              'obrigatorio': element.obrigatorio,
              'eventoColuna': element.eventoColuna,
              'inative': 'false',
              'eventoId': element.eventoId,
              'usuarioList': element.usuarioList,
              'diasAtrasoProdutoCard': element.diasAtrasoProdutoCard,
              'hsmVinculadoId': element.hsmVinculadoId,
              'modeloVinculadoId': element.modeloVinculadoId,
              'provedorVinculadoId': element.provedorVinculadoId
            })
          }
          i++
        })
        if (this.board) {
          if (this.boardName !== this.board.nome) {
            await this.onUpdateBoard(this.boardName)
          }

          if (columnsCreate && columnsCreate.length > 0) {
            await this.onCreateBoardColumn(columnsCreate)
          }

          if (columnsUpdate && columnsUpdate.length > 0) {
            await this.onUpdateBoardColumn(this.orderBoardcolumn(columnsUpdate))
          }
          loading.pop()
          this.hideModal()
          this.$emit('Back')
        }
      } else {
        toast.warning('Salve ou cancele a edição da coluna para Finalizar!')
      }
    },
    async onCreateBoardColumn (columnsCreate) {
      if (columnsCreate.length > 0) {
        await BoardRepositoryV2.Column_Create(this.board.id, columnsCreate)
          .then((response) => {
            if (response.status === 200) {
              toast.success(this.$lang.Common.Alerts.Success)
            }
          })
          .catch(this.onException)
      }
    },
    async onUpdateBoardColumn (columnsUpdate) {
      if (columnsUpdate.length > 0) {
        columnsUpdate.forEach(element => {
          console.log(element.boardId)

          BoardRepositoryV2.Column_Update(element.boardId, element.id, element)
            .then((response) => {
              if (response.status === 200) {
                toast.success(this.$lang.Common.Alerts.Success)
              }
            })
            .catch(this.onException)
        })
      }
    },
    async onUpdateBoard (name) {
      var result = false
      if (this.board) {
        this.board.nome = name
        await BoardRepository.Board_Update(this.board.id, this.board)
          .then((response) => {
            if (response.status === 200) {
              result = true
            }
          })
          .catch(this.onException)
      }
      return result
    },
    onSetAction (column, index, eventoColuna, usuarioList = null, diasAtraso = null) {
      let currentColumn = this.localColumns[index].eventoColuna
      // If user is removing the event
      if (currentColumn.some((event) => event === eventoColuna)) {
        if ((eventoColuna !== ColumnEvents.NOTIFICACAO || usuarioList.length === 0) ||
          (eventoColuna !== ColumnEvents.BLOQUEAR_AJUIZAMENTO || diasAtraso === null)) {
          currentColumn.splice(currentColumn.indexOf(eventoColuna), 1)
        }
        // If eventsColumn gets empty
        if (currentColumn.length === 0) {
          currentColumn.push(0)
        }

        return
      }
      if (eventoColuna === ColumnEvents.SERASA) {
        this.showSerasaModal(index, column)
        return
        // this.$refs.SerasaFollowUp.showModal(index, column)
      }
      if (eventoColuna === ColumnEvents.ENVIO_WHATSAPP) {
        this.showHsmModal(index, column)
        return
      }
      if (eventoColuna === ColumnEvents.MOVIMENTACAO) {
        // this.showMovimentacaoModal()
      }
      // If user is adding an event
      if (eventoColuna === 0) {
        currentColumn = [0]
      } else {
        currentColumn.some(event => event === 0)
          ? currentColumn.splice(0, 1, eventoColuna)
          : currentColumn.push(eventoColuna)
      }
    },
    onChangeColumnStatus (index, status) {
      this.localColumns[index].inative = status
    },
    showSerasaModal (index, column) {
      this.serasaModalAttributes = [index, column]
    },
    hideSerasaModal (success, index) {
      if (success) {
        let currentColumn = this.localColumns[index].eventoColuna
        currentColumn.push(ColumnEvents.SERASA)
        currentColumn = currentColumn.filter(x => x !== 0)
        this.localColumns[index].eventoColuna = currentColumn
      }
      this.serasaModalAttributes = []
    },
    showHsmModal (index, column) {
      this.hsmModalAttributes = [index, column]
    },
    hideHsmModal (success, index) {
      if (success) {
        let currentColumn = this.localColumns[index].eventoColuna
        currentColumn.push(ColumnEvents.ENVIO_WHATSAPP)
        currentColumn = currentColumn.filter(x => x !== 0)
        this.localColumns[index].eventoColuna = currentColumn
      }
      this.hsmModalAttributes = []
    },
    showMovimentacaoModal (column, index) {
      this.movimentacaoModalItems = [column.boardId, column.id, index]
      this.movimentacaoModalOpen = true
    },
    hideMovimentacaoModal () {
      // WILL MANAGE TO CHECK OR UNCHECK
      this.movimentacaoModalOpen = false
    },
    showNotificacaoModal (column, index) {
      this.notificacaoModalItems = [column, index]
      this.notificacaoModalOpen = true
    },
    hideNotificacaoModal () {
      // WILL MANAGE TO CHECK OR UNCHECK
      this.notificacaoModalOpen = false
    },
    showBlockAjuizamentoModal (column, index) {
      this.blockAjuizamentoModalItems = [column, index]
      this.blockAjuizamentoModalOpen = true
    },
    hideBlockAjuizamentoModal () {
      this.blockAjuizamentoModalOpen = false
    },
    reloadColumns () {
      this.hideModal()
      this.showModal()
      this.$emit('ReloadColumns')
    },
    closeAndSaveNotificacaoModal (usuarioList) {
      this.onSetAction(
        this.notificacaoModalItems[0],
        this.notificacaoModalItems[1],
        ColumnEvents.NOTIFICACAO,
        usuarioList)
      this.hideNotificacaoModal()
      this.$emit('Back')
    },
    closeAndSaveBlockAjuizamentoModal () {
      this.onSetAction(
        this.blockAjuizamentoModalItems[0],
        this.blockAjuizamentoModalItems[1],
        ColumnEvents.BLOQUEAR_AJUIZAMENTO)
      this.hideBlockAjuizamentoModal()
      this.$emit('Back')
    },
    orderBoardcolumn (boardcolumns) {
      let inativeBoardcolumns = []
      let activeBoardcolumns = []

      boardcolumns.forEach(obj => {
        if (obj.inative) {
          inativeBoardcolumns.push(obj)
        } else {
          activeBoardcolumns.push(obj)
        }
      })

      const orderedColumns = activeBoardcolumns.concat(inativeBoardcolumns)

      orderedColumns.forEach((obj, index) => {
        obj.posicao = index
      })

      return orderedColumns
    },
    shouldShowIcon (column) {
      return (
        Array.isArray(column.eventoColuna) &&
        column.eventoColuna.some(event => event === 5) &&
        (
          (
            Array.isArray(column.movimentacaoAutoAtrasoProduto)
              ? column.movimentacaoAutoAtrasoProduto.length > 0 && column.movimentacaoAutoAtrasoProduto.some(event => event.inative !== true)
              : (column.movimentacaoAutoAtrasoProduto && column.movimentacaoAutoAtrasoProduto !== null && typeof column.movimentacaoAutoAtrasoProduto === 'object' && column.movimentacaoAutoAtrasoProduto.inative !== true)
          ) ||
          (
            Array.isArray(column.movimentacaoAutoDiaProduto)
              ? column.movimentacaoAutoDiaProduto.length > 0 && column.movimentacaoAutoDiaProduto.some(event => event.inative !== true)
              : (column.movimentacaoAutoDiaProduto && column.movimentacaoAutoDiaProduto !== null && typeof column.movimentacaoAutoDiaProduto === 'object' && column.movimentacaoAutoDiaProduto.inative !== true)
          ) ||
          (
            column.movimentacaoAutoTempoBoardColumn &&
            (Array.isArray(column.movimentacaoAutoTempoBoardColumn)
              ? column.movimentacaoAutoTempoBoardColumn.length > 0 && column.movimentacaoAutoTempoBoardColumn.some(event => event.inative !== true)
              : (column.movimentacaoAutoTempoBoardColumn !== null && typeof column.movimentacaoAutoTempoBoardColumn === 'object' && column.movimentacaoAutoTempoBoardColumn.inative !== true))
          )
        )
      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/board/modal/collumns/boardcollumns.js